import React from 'react';
import { Can } from '@iq/react-components';
import { NavLink } from 'react-router-dom';

/**
 * Renders custom content for schema text fields (descriptions, messages, etc.)
 * Supports custom rendering with links, formatting, and context-aware content
 * @param {string} content - The content to render (e.g., schema.description, schema.noOptionsMessage, etc...)
 * @param {object} formContext - The form context with site/org data (optional for conditions.)
 * @returns {React.ReactNode|string} - The rendered content
 */
export function CustomDescription(content, formContext) {
  if (!content) return content;

  switch (content) {
    case 'SITE_IMAGE_TOOLTIP_NAVLINK': {
      if (!formContext) return content;

      const siteId = formContext.siteId || formContext.id;
      const org = formContext.org;

      return (
        <>
          Select a model thumbnail to display as site image. More info on the{' '}
          <Can
            permission="models/Write"
            scope={{ org, site: siteId }}
          >
            <NavLink
              exact
              to={{
                pathname: `/sites/${siteId}/admin/models/`,
                search: globalThis.location.search,
              }}
            >
              Models
            </NavLink>
          </Can>{' '}
          page.
        </>
      );
    }

    // Add more custom content types here as needed
    // case 'ANOTHER_CUSTOM_TYPE': {
    //   return <CustomComponent />;
    // }

    default: {
      return content;
    }
  }
}
